export const TEST_ID = 'applicationNameField';
